var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"hospitals":_vm.hospitals},on:{"fetch":function($event){return _vm.$emit('fetch')}}}),_c('List',{attrs:{"isLoading":_vm.isLoading,"list":_vm.list},on:{"fetch":_vm.fetch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }